export const COLOR_AZUL_MAIN = '#1F69AD';
export const COLOR_VERDE_MAIN = '#84B044';
export const COLOR_NARANJA_MAIN = '#FFA500';